import { Icon } from '../ui/Icons'

// Ilustraciones sencillas hechas con CSS/SVG. No son capturas de pantalla: solo
// representan el botón o elemento que el socio debe buscar.

export const SITE_URL = 'cpa.tuaplicacion.cl'

function Caption({ children }) {
  return <p className="mt-2 text-center text-xs text-text-secondary">{children}</p>
}

export function VisualFrame({ children, caption }) {
  return (
    <figure className="mx-auto mt-4 w-full max-w-sm rounded-2xl border border-dashed border-secondary/50 bg-secondary/5 p-4">
      <div className="flex flex-wrap items-center justify-center gap-3">{children}</div>
      {caption && <Caption>{caption}</Caption>}
    </figure>
  )
}

export function BrowserIcon({ name, color = 'bg-secondary' }) {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className={'grid h-16 w-16 place-items-center rounded-2xl text-white shadow-md ' + color}><Icon name="compass" className="h-9 w-9" /></span>
      <span className="text-sm font-bold text-text-primary">{name}</span>
    </div>
  )
}

export function AddressBar({ url = 'https://' + SITE_URL }) {
  return (
    <div className="w-full">
      <div className="flex min-h-12 items-center gap-2 rounded-full border border-border bg-white px-4 shadow-sm">
        <Icon name="search" className="h-4 w-4 shrink-0 text-text-secondary" />
        <span className="min-w-0 break-all text-sm font-semibold text-primary">{url}</span>
      </div>
      <p className="mt-2 text-center text-xs text-text-secondary">Barra de direcciones</p>
    </div>
  )
}

export function ShareButton() {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className="grid h-14 w-14 place-items-center rounded-2xl border-2 border-primary bg-white text-primary shadow-sm"><Icon name="share" className="h-7 w-7" /></span>
      <span className="text-sm font-bold text-text-primary">Compartir</span>
    </div>
  )
}

export function DotsButton() {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className="grid h-14 w-14 place-items-center rounded-full border-2 border-primary bg-white text-primary shadow-sm"><Icon name="dotsVertical" className="h-7 w-7" /></span>
      <span className="text-sm font-bold text-text-primary">Menú (tres puntos)</span>
    </div>
  )
}

export function MenuOption({ icon, label, highlight = true }) {
  return (
    <div className={'flex min-h-12 w-full items-center justify-between gap-3 rounded-xl border bg-white px-4 py-2 shadow-sm ' + (highlight ? 'border-success ring-2 ring-success/30' : 'border-border')}>
      <span className="font-semibold text-text-primary">{label}</span>
      {icon && <Icon name={icon} className="h-5 w-5 shrink-0 text-primary" />}
    </div>
  )
}

export function ToggleOn({ label }) {
  return (
    <div className="flex min-h-12 w-full items-center justify-between gap-3 rounded-xl border border-border bg-white px-4 py-2 shadow-sm">
      <span className="font-semibold text-text-primary">{label}</span>
      <span className="flex h-7 w-12 shrink-0 items-center justify-end rounded-full bg-success px-1" aria-label="Activado"><span className="h-5 w-5 rounded-full bg-white" /></span>
    </div>
  )
}

export function ButtonMock({ children, tone = 'primary', icon }) {
  const tones = {
    primary: 'bg-primary text-white',
    outline: 'border-2 border-secondary bg-white text-primary',
    danger: 'border border-border bg-white text-primary',
  }
  return <span className={'inline-flex min-h-12 items-center justify-center gap-2 rounded-xl px-5 py-2.5 font-semibold shadow-sm ' + tones[tone]}>{icon && <Icon name={icon} className="h-4 w-4" />}{children}</span>
}

export function HomeScreenIcon() {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className="grid h-16 w-16 place-items-center overflow-hidden rounded-2xl border border-border bg-white shadow-md"><img src="/icons/icon-192.png" alt="" width="64" height="64" className="h-full w-full object-cover" /></span>
      <span className="text-sm font-bold text-text-primary">CSPAH</span>
    </div>
  )
}

export function Arrow() {
  return <span className="text-2xl font-bold text-secondary" aria-hidden="true">→</span>
}
